import React, { useEffect, useState, useMemo } from "react"
import PropTypes from "prop-types"
import { Link, useNavigate, Redirect } from "react-router-dom"
import Select from "react-select"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons"

import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Input,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Form,
  InputGroup,
  InputGroupText,
  FormGroup,
  Label,
  UncontrolledTooltip,
  Modal,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Badge,
} from "reactstrap"
import classnames from "classnames"
import { connect } from "react-redux"
import withRouter from "components/Common/withRouter"

import {
  Pdate,
  Type,
  Value,
  ValueinUSD,
  Status,
  Coin,
  Tracked,
} from "../EcsUsers/userstabledata"

import TableContainer from "../../components/Common/TableContainer"

// import img2 from "../../assets/images/no-time-off.59f54e64.svg"

//Date Picker
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import "assets/scss/datatables.scss"

// import { cryptoOrderData } from "../../../common/data";

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"
import { getCryptoOrders } from "store/crypto/actions"

import toastr from "toastr"
import "toastr/build/toastr.min.css"
import { post } from "helpers/api_helper"
import axios from "axios"
import apiURl from "url"
import DeclineModal from "components/Common/DeclineModal"

const AllRequestsDetail = props => {
  //meta title
  document.title = "Ecs Requests"
  const navigate = useNavigate()

  // Add these state variables at the top of the AllRequestsDetail component
  const [fromDate, setFromDate] = useState(null)
  const [toDate, setToDate] = useState(null)

  // Function to handle date range filtering (ignoring hours)
  const handleDateRangeFilter = (fromDate, toDate) => {
    if (!fromDate && !toDate) {
      // If no dates are selected, return all requests for the active tab
      return requests.filter(request => request.status === activeTab)
    }

    // Convert dates to YYYY-MM-DD format for comparison
    const from = fromDate ? new Date(fromDate).toISOString().slice(0, 10) : null
    const to = toDate ? new Date(toDate).toISOString().slice(0, 10) : null

    return requests.filter(request => {
      // Ensure request matches the active tab's status
      if (request.status !== activeTab) return false

      // Use the request's created_date (already in YYYY-MM-DD format)
      const requestDate = request.created_date.slice(0, 10)

      // Filter based on date range
      if (from && to) {
        return requestDate >= from && requestDate <= to
      } else if (from) {
        return requestDate >= from
      } else if (to) {
        return requestDate <= to
      }
      return true
    })
  }

  const role_ = localStorage.getItem("role")
  const user_id = localStorage.getItem("login_user_id")
  const [requests, setRequests] = useState([])
  const fetchAllRequests = () => {
    setRequests([])
    const URL = `${apiURl}/getAllRequestsView?role=${role_}&user_id=${user_id}`
    axios
      .get(URL)
      .then(response => {
        if (response.data.status === "success") {
          setRequests(response.data.data)
          fetchUsers()
        } else {
          console.error("Failed to fetch users:", response.data.message)
        }
      })
      .catch(error => {
        console.error("Error fetching users:", error)
      })
  }

  //View Modal
  const [selectedRequest, setSelectedRequest] = useState(null)
  const [viewModal, setViewModal] = useState(false)

  const handleView = request => {
    setSelectedRequest(request)
    setViewModal(true)
  }

  //Del
  const [declineModal, setDeclineModal] = useState(false)
  const [dec_id, setDec_id] = useState(null)
  const handleStatusUpdate = id => {
    setDeclineModal(true)
    setDec_id(id)
  }

  const handleDeclineRequest = async () => {
    try {
      const URL = `${apiURl}/updateRequestStatus`
      const response = await axios.post(URL, { id: dec_id, status: "declined" })

      if (response.data.status === "success") {
        toastr.success("Request declined successfully")
        setDeclineModal(false)
        fetchAllRequests()
      } else {
        toastr.error(response.data.message || "Failed to decline Request")
      }
    } catch (error) {
      console.error("Error decline Request:", error)
      toastr.error("Failed to decline Request")
    } finally {
      setDeclineModal(false)
    }
  }

  const handleResubmitRequest = async id => {
    try {
      const URL = `${apiURl}/updateRequestStatus`
      const response = await axios.post(URL, {
        id,
        status: "resubmitted",
      })

      if (response.data.status === "success") {
        toastr.success("Request resubmitted successfully")
        fetchAllRequests()
      } else {
        toastr.error(response.data.message || "Failed to resubmit request")
      }
    } catch (error) {
      console.error("Error resubmitting request:", error)
      toastr.error("Error resubmitting request")
    }
  }
  //Selected assign
  const [selectedRequestIds, setSelectedRequestIds] = useState([])
  const [selectedEmployee, setSelectedEmployee] = useState(null)
  const [assignModalOpen, setAssignModalOpen] = useState(false)
  const handleCheckboxChange = id => {
    setSelectedRequestIds(prev => {
      const newState = prev.includes(id)
        ? prev.filter(rid => rid !== id)
        : [...prev, id]
      return newState
    })
  }

  //User
  const [fetchUsers2, setFetchUsers2] = useState([])
  const [selectedUser, setSelectedUser] = useState(null)
  const [usersCity, setUsersCity] = useState([])
  const fetchUsers = () => {
    setUsersCity([])
    const URL = `${apiURl}/fetchUsers`
    axios
      .get(URL)
      .then(response => {
        if (response.data.status === "success") {
          const allUsers = response.data.users

          // Filter only users with role "rider"
          const riders = allUsers.filter(
            user => user.role_ !== "rider" && user.role_ !== "franchises"
          )
          // Get unique cities from filtered riders
          const uniqueCities = new Set(
            riders.map(user => user.city_?.trim().toUpperCase())
          )
          setFetchUsers2(riders)
          setUsersCity(Array.from(uniqueCities))
        } else {
          console.error("Failed to fetch users:", response.data.message)
        }
      })
      .catch(error => {
        console.error("Error fetching users:", error)
      })
  }

  const handleUser = selectedOption => {
    setSelectedUser(selectedOption ? selectedOption.value : null)
  }

  useEffect(() => {
    fetchUsers()
    fetchAllRequests()
  }, [])

  //Final Assignment
  const handleAssignSubmit = async () => {
    try {
      if (!selectedUser) {
        toastr.error("Please select a user to assign")
        return
      }

      // If assigning from row button, use the selectedRequestIds from state
      // If assigning from bulk selection, use the passed requestId
      const requestIds =
        selectedRequestIds.length > 0 ? selectedRequestIds : [dec_id] // dec_id would be set when clicking from row

      const URL = `${apiURl}/assignRequestsToUser`
      const response = await axios.post(URL, {
        request_ids: requestIds,
        assigned_to: selectedUser,
        assigned_by: user_id,
      })

      if (response.data.status === "success") {
        toastr.success("Requests assigned successfully")
        fetchAllRequests()
        setAssignModalOpen(false)
        setSelectedRequestIds([])
        setSelectedUser(null)
      } else {
        toastr.error(response.data.message || "Failed to assign requests")
      }
    } catch (error) {
      console.error("Error assigning requests:", error)
      toastr.error("Failed to assign requests")
    }
  }
  // Table Data
  const columns = useMemo(
    () => [
      ...(role_ === "admin"
        ? [
            {
              Header: () => (
                <Input
                  type="checkbox"
                  className="form-check-input"
                  onChange={e => handleSelectAllChange(e.target.checked)}
                  defaultChecked={isAllSelected()}
                  indeterminate={
                    selectedRequestIds.length > 0 && !isAllSelected()
                  }
                />
              ),
              accessor: "select",
              disableFilters: true,
              disableSortBy: true,
              Cell: ({ row }) => {
                const id = row.original.REQ_ID
                const isChecked = selectedRequestIds.includes(id)
                const isSelectable =
                  !row.original.assigned_to &&
                  row.original.status !== "Approved" &&
                  row.original.status !== "declined"
                return (
                  <Input
                    type="checkbox"
                    className="form-check-input"
                    defaultChecked={isChecked}
                    onChange={() => handleCheckboxChange(id)}
                    disabled={!isSelectable}
                  />
                )
              },
            },
          ]
        : []),
      {
        Header: "ID",
        accessor: "REQ_ID",
        disableFilters: true,
        Cell: cellProps => {
          return <>{cellProps.value}</>
        },
      },
      {
        Header: "Service",
        accessor: "req_service_name",
        disableFilters: true,
        Cell: cellProps => {
          return <>{cellProps.value}</>
        },
      },

      {
        Header: "Pickup-loc",
        accessor: "pickup_location",
        disableFilters: true,
        Cell: cellProps => {
          return <>{cellProps.value}</>
        },
      },
      {
        Header: "Receiver-loc",
        accessor: "req_receiver_address",
        disableFilters: true,
        Cell: cellProps => {
          return <>{cellProps.value}</>
        },
      },
      {
        Header: "Req Status / Pay ? ",
        accessor: "status",
        disableFilters: true,
        Cell: ({ value, row }) => {
          const colorMap = {
            new: "primary",
            in_progress: "info",
            Approved: "success",
            declined: "danger",
            resubmitted: "warning",
          }
          return (
            <>
              <span
                className={`badge rounded-pill bg-${
                  colorMap[value] || "dark"
                } me-2`}
              >
                {value}
              </span>
              {(() => {
                switch (row.original.payment_status) {
                  case "paid":
                    return (
                      <Badge pill className="bg bg-success">
                        Paid
                      </Badge>
                    )
                  case "not-paid":
                  case null:
                    return (
                      <Badge pill className="bg bg-danger">
                        Not Paid
                      </Badge>
                    )
                  default:
                    return (
                      <Badge pill className="bg bg-danger">
                        Not Paid
                      </Badge>
                    )
                }
              })()}
            </>
          )
        },
      },
      {
        Header: "Request Date",
        accessor: "created_date23",
        disableFilters: true,
        Cell: cellProps => {
          const date = cellProps.row.original.created_date.slice(0, 10)
          return (
            <>
              <strong>{date}</strong>
            </>
          )
        },
      },
      ...(role_ === "admin"
        ? [
            {
              Header: "Assigned Status",
              accessor: "assigned_to",
              disableFilters: true,
              Cell: ({ row }) => {
                const assignedToId = row.original.assigned_to

                if (!assignedToId) {
                  return <span className="text-muted">Not Assigned ❌</span>
                }

                const user = fetchUsers2.find(u => u.user_id === assignedToId)

                return (
                  <span>
                    {user
                      ? `${user.full_name} (${user.city_})`
                      : "Unknown User"}
                  </span>
                )
              },
            },
          ]
        : []),
      {
        Header: "Actions",
        Cell: ({ row }) => {
          const { REQ_ID, status, assigned_to } = row.original

          // If status is 'approved', only show the View button
          if (status === "Approved") {
            return (
              <Button
                color="info"
                size="sm"
                onClick={() => handleView(row.original)}
                className="me-2"
              >
                View
              </Button>
            )
          }

          return (
            <>
              <Button
                color="info"
                size="sm"
                onClick={() => handleView(row.original)}
                className="me-2 mb-2"
              >
                View
              </Button>

              {role_ === "admin" ? (
                <>
                  {status === "declined" ? (
                    <>
                      <Button
                        color="warning"
                        size="sm"
                        onClick={() => handleResubmitRequest(REQ_ID)}
                        className="me-2 mb-2"
                      >
                        Resubmit
                      </Button>
                    </>
                  ) : (
                    <>
                      <Button
                        color="success"
                        size="sm"
                        onClick={() => navigate(`/send_courier/${REQ_ID}`)}
                        className="me-2 mb-2"
                      >
                        Process
                      </Button>
                      <Button
                        color="danger"
                        size="sm"
                        onClick={() => handleStatusUpdate(REQ_ID)}
                        className="me-2 mb-2"
                      >
                        Decline
                      </Button>

                      {assigned_to !== null ? (
                        <></>
                      ) : (
                        selectedRequestIds.length < 1 && (
                          <Button
                            color="secondary"
                            size="sm"
                            onClick={() => {
                              setDec_id(REQ_ID)
                              setAssignModalOpen(true)
                            }}
                            className="me-2 mb-2"
                          >
                            Assign
                          </Button>
                        )
                      )}
                    </>
                  )}
                </>
              ) : (
                <Button
                  color="success"
                  size="sm"
                  onClick={() => navigate(`/send_courier/${REQ_ID}`)}
                  className="me-2"
                >
                  Process
                </Button>
              )}
            </>
          )
        },
      },
    ],
    [selectedRequestIds, fetchUsers2, role_]
  )

  const [activeTab, setActiveTab] = useState("new") // Default to 'new' tab
  const handleTabChange = tabId => {
    setActiveTab(tabId)
    setSelectedRequestIds([]) // Clear selections when changing tabs
    const { pathname, search } = window.location
    const hash = `#${tabId.toLowerCase()}` // e.g. #new, #approved, #declined, #resubmitted
    window.history.replaceState(null, "", `${pathname}${search}${hash}`)
  }

  useEffect(() => {
    const applyHash = () => {
      const h = window.location.hash.replace("#", "").toLowerCase()
      const match = statusTabs.find(t => t.id.toLowerCase() === h)
      if (match) {
        setActiveTab(match.id)
      }
    }

    applyHash() // initial
    window.addEventListener("hashchange", applyHash)
    return () => window.removeEventListener("hashchange", applyHash)
  }, [])

  // Calculate request counts for each status based on filtered requests
  const requestCounts = useMemo(() => {
    const counts = {
      new: 0,
      Approved: 0,
      declined: 0,
      resubmitted: 0,
    }

    // Apply date range filtering to requests
    const filteredRequests = requests.filter(request => {
      if (!fromDate && !toDate) {
        return true // No date filters, include all requests
      }

      const requestDate = request.created_date.slice(0, 10)
      const from = fromDate
        ? new Date(fromDate).toISOString().slice(0, 10)
        : null
      const to = toDate ? new Date(toDate).toISOString().slice(0, 10) : null

      if (from && to) {
        return requestDate >= from && requestDate <= to
      } else if (from) {
        return requestDate >= from
      } else if (to) {
        return requestDate <= to
      }
      return true
    })

    // Count requests for each status from filtered results
    filteredRequests.forEach(request => {
      if (counts.hasOwnProperty(request.status)) {
        counts[request.status]++
      }
    })

    return counts
  }, [requests, fromDate, toDate])

  // Define your status tabs
  const statusTabs = [
    { id: "new", label: `New (${requestCounts.new})`, color: "secondary" },
    {
      id: "Approved",
      label: `Approved (${requestCounts.Approved})`,
      color: "success",
    },
    {
      id: "declined",
      label: `Declined (${requestCounts.declined})`,
      color: "danger",
    },
    {
      id: "resubmitted",
      label: `Resubmitted (${requestCounts.resubmitted})`,
      color: "warning",
    },
  ]

  // Filter requests based on active tab
  const filteredRequests = useMemo(() => {
    return handleDateRangeFilter(fromDate, toDate)
  }, [requests, activeTab, fromDate, toDate])

  //all Select
  const handleSelectAllChange = isChecked => {
    if (isChecked) {
      // Only select unassigned, non-approved/declined requests in current tab
      const selectableIds = filteredRequests
        .filter(
          req =>
            !req.assigned_to &&
            req.status !== "Approved" &&
            req.status !== "declined"
        )
        .map(req => req.REQ_ID)

      setSelectedRequestIds(selectableIds)
    } else {
      setSelectedRequestIds([])
    }
  }

  const isAllSelected = () => {
    const selectableRequests = filteredRequests.filter(
      req =>
        !req.assigned_to &&
        req.status !== "Approved" &&
        req.status !== "declined"
    )

    return (
      selectableRequests.length > 0 &&
      selectableRequests.every(req => selectedRequestIds.includes(req.REQ_ID))
    )
  }

  return (
    <React.Fragment>
      <DeclineModal
        show={declineModal}
        onDeleteClick={handleDeclineRequest}
        onCloseClick={() => setDeclineModal(false)}
      />
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          {/* <Breadcrumbs title="Crypto" breadcrumbItem="requests" /> */}
          <Row>
            <Col xl="6">
              <div className="d-flex align-items-center mt-2">
                <h5 className="mb-0 me-2">All Requests</h5>
              </div>
            </Col>
          </Row>

          <Row className="pt-3">
            <small style={{ color: "red" }}>
              Request's which have *Approved and *Decline Status are not Assign
              to employee Anymore
            </small>
            <Col lg="12">
              <Card>
                <CardBody>
                  <Row className="mb-3">
                    <Col md={3}>
                      <FormGroup>
                        <Label for="fromDate">From Date</Label>
                        <DatePicker
                          selected={fromDate}
                          onChange={date => setFromDate(date)}
                          selectsStart
                          startDate={fromDate}
                          endDate={toDate}
                          placeholderText="Select From Date"
                          className="form-control"
                          dateFormat="yyyy-MM-dd"
                        />
                      </FormGroup>
                    </Col>
                    <Col md={3}>
                      <FormGroup>
                        <Label for="toDate">To Date</Label>
                        <DatePicker
                          selected={toDate}
                          onChange={date => setToDate(date)}
                          selectsEnd
                          startDate={fromDate}
                          endDate={toDate}
                          minDate={fromDate}
                          placeholderText="Select To Date"
                          className="form-control"
                          dateFormat="yyyy-MM-dd"
                        />
                      </FormGroup>
                    </Col>
                    <Col md={2}>
                      <Button
                        color="secondary"
                        className="btn btn-danger mt-4"
                        size="sm"
                        onClick={() => {
                          setFromDate(null)
                          setToDate(null)
                        }}
                      >
                        Clear Dates
                      </Button>
                    </Col>
                  </Row>
                  <Nav tabs className="nav-tabs-custom">
                    {statusTabs.map(tab => (
                      <NavItem key={tab.id}>
                        <NavLink
                          className={classnames({
                            active: activeTab === tab.id,
                          })}
                          onClick={() => handleTabChange(tab.id)}
                        >
                          <span className={`btn btn-sm btn-${tab.color}`}>
                            {tab.label}
                          </span>
                        </NavLink>
                      </NavItem>
                    ))}
                  </Nav>
                  <TabContent
                    activeTab={activeTab}
                    className="p-3 border border-top-0"
                  >
                    <TabPane tabId={activeTab}>
                      <div className="float-end">
                        {selectedRequestIds.length > 0 && (
                          <div className="mt-3">
                            <span className="me-2">
                              {selectedRequestIds.length} selected in this tab
                            </span>
                            <Button
                              color="primary"
                              className="btn btn-sm"
                              onClick={() => setAssignModalOpen(true)}
                            >
                              Assign Selected
                            </Button>
                          </div>
                        )}
                      </div>

                      <TableContainer
                        columns={columns}
                        data={filteredRequests}
                        isGlobalFilter={true}
                        isAddOptions={false}
                        customPageSize={10}
                      />
                    </TabPane>
                  </TabContent>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <Modal isOpen={viewModal} toggle={() => setViewModal(false)} size="sm">
        <ModalHeader toggle={() => setViewModal(false)}>
          Request Details
        </ModalHeader>
        <ModalBody>
          {selectedRequest && (
            <>
              <Row>
                <Col md={12}>
                  <div>
                    <p>
                      <strong>Sender:</strong> {selectedRequest.req_sender_name}
                    </p>
                    <p>
                      <strong>Receiver:</strong>{" "}
                      {selectedRequest.req_receiver_name}
                    </p>
                    <p>
                      <strong>Service:</strong>{" "}
                      {selectedRequest.req_service_name}
                    </p>
                    <p>
                      <strong>Pickup:</strong> {selectedRequest.pickup_location}
                    </p>

                    <p>
                      <strong>Delivery:</strong>{" "}
                      {selectedRequest.req_receiver_address}
                    </p>
                    {
                      selectedRequest?.req_service_name !== 'General' &&
                    <p>
                      <strong>No of Working Days:</strong>{" "}
                      {selectedRequest?.noOfWorkingDays}
                    </p>
                    }
                    <p>
                      <strong>Request Date:</strong>{" "}
                      <Badge pill className="bg bg-primary">
                        {selectedRequest.created_date.slice(0, 10)}
                      </Badge>
                    </p>
                    <p>
                      <strong>Payment Status:</strong>{" "}
                      {(() => {
                        switch (selectedRequest.payment_status) {
                          case "paid":
                            return (
                              <Badge pill className="bg bg-success">
                                Paid
                              </Badge>
                            )
                          case "not-paid":
                          case null:
                            return (
                              <Badge pill className="bg bg-danger">
                                Not Paid
                              </Badge>
                            )
                          default:
                            return (
                              <Badge pill className="bg bg-danger">
                                Not Paid
                              </Badge>
                            )
                        }
                      })()}
                    </p>
                    
                    {/* Add other fields as needed */}
                  </div>
                </Col>
              </Row>
            </>
          )}
        </ModalBody>
        <ModalFooter>
          <Button
            className="btn btn-sm"
            color="secondary"
            onClick={() => setViewModal(false)}
          >
            Close
          </Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={assignModalOpen} toggle={() => setAssignModalOpen(false)}>
        <ModalHeader toggle={() => setAssignModalOpen(false)}>
          {selectedRequestIds.length > 1
            ? `Assign ${selectedRequestIds.length} Selected Requests`
            : "Assign Request"}
        </ModalHeader>
        <ModalBody>
          <div className="mb-3">
            {selectedRequestIds.length > 1 ? (
              <p style={{ color: "red" }}>
                You are about to assign {selectedRequestIds.length} requests to
                a user.
              </p>
            ) : (
              <p style={{ color: "red" }}>
                You are about to assign request ID: {dec_id} to a user.
              </p>
            )}
            <p>AD(Admin), SU(Sub Admin), EM(Employee)</p>
          </div>
          <div className="col-sm-auto">
            <Label className="control-label" htmlFor="selectedUser">
              Select User
            </Label>
            <Select
              classNamePrefix="select2-selection"
              value={
                fetchUsers2
                  .map(e => ({
                    value: e.user_id,
                    label: `${e.role_.substring(0, 2).toUpperCase()}: ${
                      e.full_name
                    } (${e.city_})`,
                  }))
                  .find(option => option.value === selectedUser) || null
              }
              placeholder="Select User ..."
              name="selectedUser"
              onChange={handleUser}
              options={[
                ...(fetchUsers2.length > 0
                  ? fetchUsers2.map(e => ({
                      value: e.user_id,
                      label: `${e.role_.substring(0, 2).toUpperCase()}: ${
                        e.full_name
                      } (${e.city_})`,
                    }))
                  : [{ value: "", label: "No data Found" }]),
              ]}
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setAssignModalOpen(false)}>
            Cancel
          </Button>
          <Button color="primary" onClick={handleAssignSubmit}>
            Confirm Assignment
          </Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  )
}

export default AllRequestsDetail
